// extracted by mini-css-extract-plugin
export default {"downloadInput":"Footer__downloadInput__pWVRn","sendLinkButton":"Footer__sendLinkButton__dqqBA","socialMediaLink":"Footer__socialMediaLink__kcWoz","borderColor":"Footer__borderColor__A8B_l","marginLeft":"Footer__marginLeft__HLONF","listStyleNone":"Footer__listStyleNone__QCbYS"};
    if(module.hot) {
      // 1763020729368
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  